module.exports = __webpack_public_path__ + "static/media/chevron_up.d6f48624.svg";